var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBlueFollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.19922,
  width: 17,
  height: 17,
  rx: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.625 14.6992H8.375V10.3242H4V9.07422H8.375V4.69922H9.625V9.07422H14V10.3242H9.625V14.6992Z",
  fill: "#4585FF"
})));
export default SvgIconBlueFollow;